<template>
    <div
        class="question-box"
    >
        <div
            ref="textOverflow"
            :class="[
                'question-content',
                {'line-clamp-style': !isShrinkOnce}
            ]"
            :style="boxStyle"
        >
            <!--bca-disable-->
            <span
                ref="overEllipsis"
                class="question-content-text"
                v-html="isShowAll ? text : realText"
            >
            </span>
            <!--bca-enable-->
            <span
                v-if="showSlotNode && !isShowAll"
                ref="question-content-all"
                class="question-content-all"
                @click="showAll"
            >
                查看全部<veui-icon class="icon" name="chevron-down" />
                <veui-tooltip
                    v-if="isPop"
                    :open.sync="open"
                    :target="target"
                    :position="position"
                    trigger="click"
                    :aim-center="true"
                >
                    {{ text }}
                    <div class="up-btn" @click.stop="closeShowAll">
                        收起<veui-icon class="icon" name="chevron-up"/>
                    </div>
                </veui-tooltip>
            </span>
            <span
                v-if="!isPop && isShowAll"
                class="up-btn-box"
                :style="{bottom: `${styleInfo.expandBtnBottom}px`}"
            >
                <div
                    class="up-btn"
                    @click.stop="closeShowAll"
                >
                    收起<veui-icon class="icon" name="chevron-up"/>
                </div>
            </span>
        </div>
    </div>
</template>

<script>
import {Icon, Tooltip} from 'veui';
import 'veui-theme-dls-icons';

export default {
    components: {
        'veui-icon': Icon,
        'veui-tooltip': Tooltip
    },
    props: {
        // 原始文本内容
        text: {
            'type': String,
            'default': ''
        },
        // 最大行数
        maxLines: {
            'type': Number,
            'default': 2
        },
        // 容器宽度
        width: {
            'type': [Number, String],
            'default': ''
        },
        // 类型: list 其他 ''
        from: {
            'type': String,
            'default': ''
        },
        isPop: {
            'type': Boolean,
            default: true
        },
        styleInfo: {
            'type': Object,
            default: () => {}
        }
    },
    data() {
        return {
            isShowAll: false,
            target: null,
            position: null,
            open: false,
            offset: this.text.length,
            expanded: false,
            slotBoxWidth: 0,
            textBoxWidth: this.width,
            showSlotNode: false,
            isWatchText: false,
            isShrinkOnce: false
        };
    },
    computed: {
        boxStyle() {
            let args = {};
            if (this.width) {
                args.width = this.width + 'px';
            }
            else {
                args.width = '100%';
            }
            if (!this.isShrinkOnce) {
                args = {
                    ...args,
                    '-webkit-line-clamp': this.maxLines,
                    'line-clamp': this.maxLines
                };
            }
            return args;
        },
        // 截取展示内容
        realText() {
            // 是否被截取
            const isCutOut = this.offset !== this.text.length;
            let realText = this.text;
            if (isCutOut && !this.expanded) {
                realText = this.text.slice(0, this.offset) + '...';
            }
            return realText;
        }
    },
    methods: {
        showAll() {
            this.$emit('showAll');
            if (this.from === 'list') {
                this.target = this.$refs['question-content-all'];
                this.position = 'bottom';
                this.open = true;
                return;
            }
            this.isShrinkOnce = true;
            this.isShowAll = !this.isShowAll;
        },
        closeShowAll() {
            this.open = false;
            this.isShowAll = false;
        },
        calculateOffset(from, to) {
            this.$nextTick(() => {
                if (Math.abs(from - to) <= 1) {
                    return;
                }
                if (this.isOverflow()) {
                    to = this.offset;
                }
                else {
                    from = this.offset;
                }
                this.offset = Math.floor((from + to) / 2);
                this.calculateOffset(from, to);
            });
        },
        isOverflow() {
            const {len, lastWidth} = this.getLines();
            if (len < this.maxLines) {
                return false;
            }
            if (this.maxLines) {
                // 超出部分 行数 > 最大行数 或则  已经是最大行数但最后一行宽度 + 后面内容超出正常宽度
                const lastLineOver = !!(
                    len === this.maxLines && lastWidth + this.slotBoxWidth > this.textBoxWidth
                );
                if (len > this.maxLines || lastLineOver) {
                    return true;
                }
            }
            return false;
        },
        getLines() {
            const clientRects = this.$refs.overEllipsis.getClientRects();
            return {
                len: clientRects.length,
                lastWidth: clientRects[clientRects.length - 1].width
            };
        }
    },
    watch: {
        text(next, pre) {
            if (next && this.isWatchText && next === pre) {
                return;
            }
            this.isWatchText = true;
            this.showSlotNode = false;
            this.offset = next.length;
            try {
                this.$nextTick(() => {
                    const {len} = this.getLines();
                    if (len > this.maxLines) {
                        this.showSlotNode = true;
                        this.slotBoxWidth = 90;
                        this.textBoxWidth = this.$refs.textOverflow.clientWidth;
                        setTimeout(() => {
                            this.calculateOffset(0, next.length);
                        });
                    }
                    else {
                        this.showSlotNode = false;
                        this.offset = next.length;
                    }
                });
            }
            catch (error) {};
        }
    },
    mounted() {
        try {
            if (this.text && this.isWatchText) {
                return;
            }
            this.isWatchText = true;
            this.tipWidth = this.$refs.tip && this.$refs.tip.clientWidth || 0;
            const {len} = this.getLines();
            if (len > this.maxLines) {
                this.showSlotNode = true;
                this.$nextTick(() => {
                    this.slotBoxWidth = 90;
                    this.textBoxWidth = this.$refs.textOverflow.clientWidth;
                    this.calculateOffset(0, this.text.length);
                });
            }
        }
        catch (error) {};
        this.isInit = true;
    }
};
</script>

<style lang="stylus" scoped>
.question-box {
    width: 100%;
    box-sizing: border-box;
    font-family: PingFangSC-Regular;
    font-size: 14px;

    .question-content {
        position: relative;
        width: 100%;
        line-height: 26px;
        font-size: 14px;
        color: #333;

        &.line-clamp-style {
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
        }

        .question-content-all {
            position: absolute;
            bottom: 0;
            right: 0;
            color: #0047FF;
            cursor: pointer;

            .icon {
                font-size: 14px;
            }

        }
    }

    .question-content-text {
        white-space: normal;
    }
}
.up-btn-box {
    position: absolute;
    z-index: 1;
    bottom: -30px;
    right: 0;
}
.up-btn {
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #0047FF;
    text-align: right;
    line-height: 26px;
    cursor: pointer;
    margin-top: 12px;
}
.background-none
    background: none;
/deep/ .veui-tooltip
    max-width: 300px;
    padding: 24px;
    border-radius: 8px;
    box-sizing: border-box;
    font-size: 14px;
</style>
